import { render, staticRenderFns } from "./OtherSupply.vue?vue&type=template&id=620c7817&scoped=true"
import script from "./OtherSupply.vue?vue&type=script&lang=js"
export * from "./OtherSupply.vue?vue&type=script&lang=js"
import style0 from "./OtherSupply.vue?vue&type=style&index=0&id=620c7817&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "620c7817",
  null
  
)

export default component.exports